/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart, useSubEnv} from "@odoo/owl";
//import { useService } from "@web/core/utils/hooks";
import {WPCPortalStudentClassList} from "@wpc_portal/components/student_class_list/student_class_list";
import {WPCPortalStudentPlacementList} from "@wpc_portal/components/student_placement_list/student_placement_list";
import {IsTomSelect} from "@wpc_portal/components/tom_select/tom_select";


export class WPCPortalStudentPortal extends Component {
    static template = 'wpc_portal.student_portal'
    static components = {
        WPCPortalStudentClassList,
        WPCPortalStudentPlacementList,
        IsTomSelect,
    }
    static defaultProps = {
    }
    setup() {
        var self = this;
        self.moveNextPageButton = useRef('moveNextPageButton');
        self.movePreviousPage = useRef('movePreviousPage');

        self.state = useState({
            class_list: [],
            school_list: [],
            placement_list: [],
            profile: {},
            saving: false,
        });

//        useSubEnv({
////            ...self.env,
//            wpc_student_state: self.state,
//        });

        useEffect(()=>{
            self.get_profile();
        }, ()=>[])
    }

    get_profile(){
        var self = this;
        return $.getJSON({url: '/api/student/profile'}).then(data=>{
            self.state.profile = data;
        });
    }

    getSchoolListItems(query, callback){
        var self = this;
        return $.getJSON({url: '/api/student/school_list?search=' + query}).then(data=>{
            console.log('ITEMS', data);
            callback(data || []);
            callback([]);
        }).catch(()=>{
            callback([]);
        });
    }

    onSubmit(event) {
        const form = event.target;
        const formData = new FormData(form);

        // Keep unticked checkboxes
        form.querySelectorAll('input[type="checkbox"]').forEach(o => {
            if (!formData.has(o.name) && o.name) {
                formData.append(o.name, 'false');
            }
        });

        const data = Object.fromEntries(formData.entries());

        this.state.saving = true;

        console.log('SAVE', event.submitter.name, data);

        return $.ajax({url: '/api/student/profile', dataType: 'json', type:'POST', data:
            {...data},
        }).then(res=>{
            if (event.submitter.name === 'moveNextPage'){
                this.props.wpc_state.goNextMenu()
            }
            else if (event.submitter.name === 'movePreviousPage'){
                this.props.wpc_state.goPreviousMenu()
            }
        }).then(()=>{
            this.state.saving = false;
        }).catch(err=>{
            console.log(err);
            alert(JSON.stringify(err));
            this.state.saving = false;
        })

    }
}
